export const brandColours = {
	white: '#fff',
	offWhite: '#f9fafc',
	lightGrey: '#afb5bf',
	black: '#000',
	offBlack: '#192f39',
	primary: '#e94e1b',
	primaryDark: '#de2c05',
	secondary: '#e63946',
};

export const lightTheme = {
	body: brandColours.offWhite,
	text: brandColours.offBlack,
	headline: brandColours.black,
	grey: '#666',
	primary: brandColours.primaryDark,
};
export const darkTheme = {
	body: brandColours.black,
	text: brandColours.lightGrey,
	headline: brandColours.white,
	grey: '#ccc',
	primary: brandColours.primary,
};
